import { ColDef } from 'ag-grid-community';

import { GlobalContextData, ValidationErrorsMessage } from '../../../../../../common/types';
import {
  defaultColumnDefinition,
  defaultColumnDefinitionWithFilter,
  defaultColumnDefinitionWithoutWidth,
} from '../../../../shared/columnDefinitions';

import ResolveLinkCellRenderer from './resolveLinkCellRenderer';
import IgnoreLinkCellRenderer from './ignoreLinkCellRenderer';

const descriptionCellStyle = {
  textAlign: 'left' as const,
  whiteSpace: 'normal' as const,
  wordBreak: 'break-word' as const,
  lineHeight: '1.35',
};

export const getColumnDefinitions = (
  handleButtonClick: (errorDetails: ValidationErrorsMessage) => void,
  handleIgnoreButtonClick: (errorDetails: ValidationErrorsMessage) => void,
  { taxYear, period, businessEntityId, jurisdictionId, filingTypeId }: GlobalContextData,
) => {
  const columnDefinitions: ColDef[] = [
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Type',
      field: 'type',
      width: 100,
      maxWidth: 120,
      suppressSizeToFit: true,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Validation Type',
      field: 'validationType',
      width: 150,
      maxWidth: 180,
      suppressSizeToFit: true,
    },
    {
      ...defaultColumnDefinitionWithoutWidth,
      filter: defaultColumnDefinitionWithFilter.filter,
      menuTabs: defaultColumnDefinitionWithFilter.menuTabs,
      headerName: 'Description',
      field: 'description',
      flex: 3,
      minWidth: 250,
      autoHeight: true,
      wrapText: true,
      cellStyle: descriptionCellStyle,
    },
    {
      ...defaultColumnDefinition,
      headerName: 'Location',
      field: 'location',
      width: 100,
      hide: true,
    },
    {
      ...defaultColumnDefinitionWithoutWidth,
      filter: defaultColumnDefinitionWithFilter.filter,
      menuTabs: defaultColumnDefinitionWithFilter.menuTabs,
      headerName: 'Element',
      field: 'element',
      tooltipField: 'element',
      flex: 1,
      minWidth: 140,
      cellStyle: descriptionCellStyle,
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: '',
      colId: 'status',
      field: 'status',
      width: 120,
      minWidth: 120,
      suppressSizeToFit: true,
      cellRenderer: ResolveLinkCellRenderer,
      cellRendererParams: {
        taxYear,
        period,
        businessEntityId,
        jurisdictionId,
        filingTypeId,
        handleButtonClick,
      },
    },
    {
      ...defaultColumnDefinitionWithFilter,
      headerName: 'Ignore',
      colId: 'ignore',
      field: 'ignore',
      width: 120,
      minWidth: 120,
      suppressSizeToFit: true,
      cellRenderer: IgnoreLinkCellRenderer,
      cellRendererParams: {
        handleIgnoreButtonClick,
      },
    },
  ];

  return columnDefinitions;
};
